import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-scroll-icon',
  templateUrl: 'scroll-icon.component.html'
})
export class ScrollIconComponent {
  constructor() {}
}
